export const BREAKEPOINT_SM_UP = 576
export const BREAKEPOINT_MD_UP = 768
export const BREAKEPOINT_LG_UP = 1024
export const BREAKEPOINT_XLG_UP = 1200
export const BREAKEPOINT_XXLG_UP = 1600
export const windowGlobal = typeof window !== 'undefined' && window
